export default __webpack_public_path__ + "static/media/mapaCifras.4b620a12.png";